export const SET_TIPOS_CONCEDENTES = "TIPOS_CONCEDENTES/SET_TIPOS_CONCEDENTES";
export const SET_TIPO_CONCEDENTE = "TIPOS_CONCEDENTES/SET_TIPO_CONCEDENTE";
export const SET_PAGINATION = "TIPOS_CONCEDENTES/SET_PAGINATION";
